import { Button } from "@chakra-ui/button";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from "@chakra-ui/modal";
import React from "react";

export interface WarningDialogProps {
  isOpen: boolean;
  onCloseHandler?: () => void;
  onConfirmHandler?: () => void;
  titleText: string;
  contentText: string;
  confirmText: string;
  danger?: boolean;
}

function WarningDialog(props: WarningDialogProps) {
  const {
    onCloseHandler,
    onConfirmHandler,
    contentText,
    titleText,
    confirmText,
    danger = true,
  } = props;
  const [isOpen, setIsOpen] = React.useState(props.isOpen ?? false);
  const cancelRef = React.useRef(null);

  React.useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  const handleClose = () => {
    setIsOpen(!isOpen);
    if (onCloseHandler) {
      onCloseHandler();
    }
  };

  const handleConfirm = () => {
    setIsOpen(!isOpen);
    if (onConfirmHandler) {
      onConfirmHandler();
    }
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={handleClose}
      leastDestructiveRef={cancelRef}
      isCentered
      closeOnOverlayClick={false}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {titleText}
          </AlertDialogHeader>

          <AlertDialogBody>{contentText}</AlertDialogBody>

          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={handleClose}
              data-testid={`${titleText}-cancel`}
            >
              Cancel
            </Button>
            <Button
              colorScheme={danger ? "red" : undefined}
              variant={danger ? "solid" : "brand"}
              onClick={handleConfirm}
              ml={3}
              data-testid={`${titleText}-confirm`}
            >
              {confirmText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default WarningDialog;
